import { render, staticRenderFns } from "./AMAfaR2.vue?vue&type=template&id=1efd188e&scoped=true"
import script from "./AMAfaR2.vue?vue&type=script&lang=ts"
export * from "./AMAfaR2.vue?vue&type=script&lang=ts"
import style0 from "./AMAfaR2.vue?vue&type=style&index=0&id=1efd188e&prod&lang=scss&scoped=true"
import style1 from "./AMAfaR2.vue?vue&type=style&index=1&id=1efd188e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efd188e",
  null
  
)

export default component.exports